export const observeOneTrustAccessibility = root => {
  const update = () => {
    const banner = root.querySelector("#onetrust-banner-sdk")
    // Keep programmatic focus available without adding a noninteractive tab stop.
    if (banner?.hasAttribute("tabindex") && banner.tabIndex >= 0) {
      banner.setAttribute("tabindex", "-1")
    }

    root.querySelectorAll("a.ot-cookie-policy-link").forEach(link => {
      const visibleText = (link.innerText ?? link.textContent ?? "")
        .replace(/\s+/g, " ")
        .trim()
      if (!visibleText) return

      const label =
        link.target === "_blank" &&
        !/opens? in (a )?new (tab|window)/i.test(visibleText)
          ? `${visibleText}, opens in a new tab`
          : visibleText
      if (link.getAttribute("aria-label") !== label) {
        link.setAttribute("aria-label", label)
      }
    })
  }

  const observer = new MutationObserver(mutations => {
    if (
      mutations.some(
        mutation =>
          mutation.type === "childList" ||
          mutation.type === "characterData" ||
          mutation.target.id === "onetrust-banner-sdk" ||
          mutation.target.matches?.("a.ot-cookie-policy-link")
      )
    ) {
      update()
    }
  })
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
    attributeFilter: ["tabindex", "aria-label", "target"],
  })
  update()
  return () => observer.disconnect()
}
